// Make YOAST FAQ block an accordion, marked up like lohko's accordion item:
// the question becomes a button in a heading with a chevron at the far end,
// and the answer goes in a region wrapped twice so it can slide open (see
// partials/_accordion.scss). One question is open at a time; a link to a
// question's id opens it.
document.addEventListener("DOMContentLoaded", () => {
  const sections = Array.from(
    document.querySelectorAll<HTMLElement>(".schema-faq .schema-faq-section"),
  );

  const setOpen = (section: HTMLElement, open: boolean) => {
    section.classList.toggle("active", open);
    section
      .querySelector(".schema-faq-question")
      ?.setAttribute("aria-expanded", String(open));
  };

  sections.forEach((section, index) => {
    const question = section.querySelector(".schema-faq-question");
    const answer = section.querySelector(".schema-faq-answer");
    if (!question || !answer) return;

    const id = section.id || `faq-question-${index + 1}`;
    section.id = id;

    const heading = document.createElement("h3");
    heading.className = "schema-faq-header";

    const button = document.createElement("button");
    button.type = "button";
    button.id = `${id}-toggle`;
    button.className = "schema-faq-question";
    button.setAttribute("aria-expanded", "false");
    button.setAttribute("aria-controls", `${id}-answer`);

    const title = document.createElement("span");
    title.className = "schema-faq-title";
    title.innerHTML = question.innerHTML;

    const toggle = document.createElement("span");
    toggle.className = "schema-faq-toggle";
    toggle.setAttribute("aria-hidden", "true");
    toggle.innerHTML = '<span class="schema-faq-toggle-icon"></span>';

    button.append(title, toggle);
    heading.append(button);

    const content = document.createElement("div");
    content.id = `${id}-answer`;
    content.className = "schema-faq-content";
    content.setAttribute("role", "region");
    content.setAttribute("aria-labelledby", button.id);

    const clip = document.createElement("div");
    clip.className = "schema-faq-clip";
    const body = document.createElement("div");
    body.className = "schema-faq-body";

    // Yoast leaves whitespace text nodes between its elements; drop them
    // along with the originals.
    section.replaceChildren(heading, content);
    content.append(clip);
    clip.append(body);
    body.append(answer);

    button.addEventListener("click", () => {
      const wasOpen = section.classList.contains("active");
      sections.forEach((other) => setOpen(other, false));
      setOpen(section, !wasOpen);
    });
  });

  const hash = decodeURIComponent(window.location.hash.slice(1));
  const target = sections.find((section) => hash && section.id === hash);
  if (target) setOpen(target, true);
});
